import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileManagementComponent } from './profile-management.component';
import { ProfileManagementRoutingModule } from './profile-management-routing.module';
import { SharedModule } from '../../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ProfileManagementRoutingModule,
    SharedModule
  ],
  declarations: [ProfileManagementComponent]
})
export class ProfileManagementModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/profile-management/profile-management.module.ts